/**
 * Check if a point is inside a polygon using the ray-casting algorithm
 */
export function pointInPolygon(point: [number, number], polygon: [number, number][]): boolean {
    let x = point[0], y = point[1];
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        let xi = polygon[i][0], yi = polygon[i][1];
        let xj = polygon[j][0], yj = polygon[j][1];
        let intersect = ((yi > y) !== (yj > y)) &&
            (x < (xj - xi) * (y - yi) / (yj - yi + 0.0000001) + xi);
        if (intersect) inside = !inside;
    }
    return inside;
}

/**
 * Generate a convex hull from a set of points using Andrew's monotone chain algorithm
 */
export function convexHull(points: [number, number][]): [number, number][] {
    points = points.slice().sort(([aLat, aLng], [bLat, bLng]) =>
        aLat === bLat ? aLng - bLng : aLat - bLat
    );
    const n = points.length;
    if (n <= 1) return points;

    const lower: [number, number][] = [];
    for (let i = 0; i < n; i++) {
        while (
            lower.length >= 2 &&
            cross(lower[lower.length - 2], lower[lower.length - 1], points[i]) <= 0
        ) {
            lower.pop();
        }
        lower.push(points[i]);
    }

    const upper: [number, number][] = [];
    for (let i = n - 1; i >= 0; i--) {
        while (
            upper.length >= 2 &&
            cross(upper[upper.length - 2], upper[upper.length - 1], points[i]) <= 0
        ) {
            upper.pop();
        }
        upper.push(points[i]);
    }

    lower.pop();
    upper.pop();
    return lower.concat(upper);
}

/**
 * Helper function for convex hull calculation
 */
function cross(
    o: [number, number],
    a: [number, number],
    b: [number, number]
): number {
    return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]);
} 